import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class BigSquidTentacleCorpse extends OrganicMobCorpse {
	static key = "BigSquidTentacleCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): BigSquidTentacleCorpse {
		const c = new BigSquidTentacleCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
